export default "__VITE_ASSET__f9438015__"